import React from 'react';

const strokeWidth = '2';
const SEKLogo = ({width, height}) => (
  <svg 
    viewBox="0 0 399 207"
    width={width}
    height={height}
  >
    <title>SEK Svensk Elstandard</title>
    <defs>
      <path id="a" d="M.06.833h204.069V207H.06z" />
    </defs>
    <g fill="none">
      <path
        fill="#00a0df"
        d="M110.399.833L0 206.933l94.105.067L204.129.833h-93.73"
        mask="url(#b)"
      />
      <path
        fill="#FFFFFE"
        d="M90.874 83.013c-.041-.025-6.244-3.256-6.244-3.256-.019-.011-.274-.132-.274-.132-2.458-1.162-5.238-2.482-5.238-5.377 0-3.118 2.407-5.57 5.479-5.57 2.573 0 4.55 1.162 6.051 3.541l.385.612.555-.462 1.467-1.208.406-.334-.255-.459c-1.649-2.975-4.98-4.889-8.483-4.889-5.182 0-8.942 3.716-8.942 8.853 0 2.712 1.232 4.848 3.656 6.36.047.016 5.898 3.114 5.898 3.114.016.003.601.296.601.296 2.629 1.279 5.605 2.728 5.605 5.735 0 3.815-3.38 7.03-7.376 7.03-4.194 0-6.257-2.969-7.245-5.46l-.246-.615-.605.27-1.811.829-.533.238.202.555c1.643 4.552 5.535 7.387 10.152 7.387 5.851 0 10.793-4.607 10.793-10.061 0-3.052-1.271-5.28-3.998-6.997M147.432 98.734l-16.426-16.38 15.434-15.188 1.104-1.088h-4.561l-.187.189-14.332 14.094V66.078h-3.335v33.736h3.335V84.81l.226-.236 15.322 15.24h4.507l-1.087-1.08M117.821 65.908h-16.135v33.729h16.771v-3.202h-13.433V69.113h13.433v-3.205h-.636"
      />
      <path
        fill="#FFFFFE"
        d="M114.211 76.435l-.644.642-5.931 5.928-.313.317 1.042 2.226.385.814.631-.642 5.935-5.931.308-.311-.179-.402-.853-1.821-.381-.82"
      />
      <path
        fill="#1A1919"
        d="M171.3 122.066c-1.579-2.509-3.811-4.133-7.114-4.133-3.77 0-6.605 3.023-6.605 6.692 0 3.675 3.487 5.212 6.321 6.557l6.701 3.483c2.65 1.679 4 3.822 4 6.983 0 5.807-5.305 10.176-10.978 10.176-4.885 0-8.696-3.018-10.329-7.524l1.955-.886c1.489 3.725 4.233 6.322 8.47 6.322 4.602 0 8.65-3.626 8.65-8.274 0-3.959-4.048-5.632-7.072-7.119l-6.321-3.347c-2.33-1.438-3.632-3.489-3.632-6.277 0-5.212 3.724-8.887 8.979-8.887 3.533 0 6.882 1.909 8.553 4.928l-1.578 1.306"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M171.3 122.066c-1.579-2.509-3.811-4.133-7.114-4.133-3.77 0-6.605 3.023-6.605 6.692 0 3.675 3.487 5.212 6.321 6.557l6.701 3.483c2.65 1.679 4 3.822 4 6.983 0 5.807-5.305 10.176-10.978 10.176-4.885 0-8.696-3.018-10.329-7.524l1.955-.886c1.489 3.725 4.233 6.322 8.47 6.322 4.602 0 8.65-3.626 8.65-8.274 0-3.959-4.048-5.632-7.072-7.119l-6.321-3.347c-2.33-1.438-3.632-3.489-3.632-6.277 0-5.212 3.724-8.887 8.979-8.887 3.533 0 6.882 1.909 8.553 4.928l-1.578 1.306z"
      />
      <path
        fill="#1A1919"
        d="M190.184 146.253h.09l10.377-29.95h2.23l-12.748 36.228-12.604-36.228h2.238l10.417 29.95"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M190.184 146.253h.09l10.377-29.95h2.23l-12.748 36.228-12.604-36.228h2.238z"
      />
      <path
        fill="#1A1919"
        d="M210.04 118.392v12.746h14.146v2.094H210.04v16.039h14.515v2.1h-16.746v-35.074h16.746v2.095H210.04"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M210.04 118.392v12.746h14.146v2.094H210.04v16.039h14.515v2.1h-16.746v-35.074h16.746v2.095z"
      />
      <path
        fill="#1A1919"
        d="M263.528 152.531l-29.44-31.302v30.142h-2.232v-35.539l29.437 31.071v-30.606h2.235v36.234"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M263.528 152.531l-29.44-31.302v30.142h-2.232v-35.539l29.437 31.071v-30.606h2.235z"
      />
      <path
        fill="#1A1919"
        d="M286.534 122.066c-1.586-2.509-3.821-4.133-7.116-4.133-3.769 0-6.613 3.023-6.613 6.692 0 3.675 3.49 5.212 6.328 6.557l6.703 3.483c2.647 1.679 3.997 3.822 3.997 6.983 0 5.807-5.305 10.176-10.977 10.176-4.881 0-8.695-3.018-10.328-7.524l1.961-.886c1.488 3.725 4.226 6.322 8.463 6.322 4.603 0 8.652-3.626 8.652-8.274 0-3.959-4.049-5.632-7.076-7.119l-6.324-3.347c-2.323-1.438-3.625-3.489-3.625-6.277 0-5.212 3.724-8.887 8.976-8.887 3.535 0 6.885 1.909 8.555 4.928l-1.576 1.306"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M286.534 122.066c-1.586-2.509-3.821-4.133-7.116-4.133-3.769 0-6.613 3.023-6.613 6.692 0 3.675 3.49 5.212 6.328 6.557l6.703 3.483c2.647 1.679 3.997 3.822 3.997 6.983 0 5.807-5.305 10.176-10.977 10.176-4.881 0-8.695-3.018-10.328-7.524l1.961-.886c1.488 3.725 4.226 6.322 8.463 6.322 4.603 0 8.652-3.626 8.652-8.274 0-3.959-4.049-5.632-7.076-7.119l-6.324-3.347c-2.323-1.438-3.625-3.489-3.625-6.277 0-5.212 3.724-8.887 8.976-8.887 3.535 0 6.885 1.909 8.555 4.928l-1.576 1.306z"
      />
      <path
        fill="#1A1919"
        d="M313.721 116.297h2.973l-17.162 16.887 18.236 18.187h-2.932l-16.839-16.75-.93.93v15.82h-2.233v-35.074h2.233v16.372l16.654-16.372"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M313.721 116.297h2.973l-17.162 16.887 18.236 18.187h-2.932l-16.839-16.75-.93.93v15.82h-2.233v-35.074h2.233v16.372z"
      />
      <path
        fill="#1A1919"
        d="M132.421 169.4v12.746h14.139v2.084h-14.139v16.049h14.512v2.099h-16.745v-35.072h16.745v2.094h-14.512"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M132.421 169.4v12.746h14.139v2.084h-14.139v16.049h14.512v2.099h-16.745v-35.072h16.745v2.094z"
      />
      <path
        fill="#1A1919"
        d="M156.461 200.279h8.932v2.094h-11.16V167.31h2.228v32.969"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M156.461 200.279h8.932v2.094h-11.16V167.31h2.228z"
      />
      <path
        fill="#1A1919"
        d="M187.066 173.08c-1.579-2.516-3.816-4.139-7.114-4.139-3.768 0-6.604 3.017-6.604 6.693 0 3.674 3.488 5.211 6.322 6.561l6.693 3.484c2.658 1.674 4.007 3.817 4.007 6.977 0 5.808-5.3 10.181-10.98 10.181-4.881 0-8.693-3.017-10.326-7.529l1.959-.885c1.488 3.717 4.229 6.327 8.461 6.327 4.606 0 8.652-3.631 8.652-8.28 0-3.947-4.046-5.621-7.073-7.113l-6.324-3.354c-2.324-1.443-3.625-3.482-3.625-6.277 0-5.205 3.721-8.881 8.976-8.881 3.532 0 6.885 1.905 8.562 4.922l-1.586 1.313"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M187.066 173.08c-1.579-2.516-3.816-4.139-7.114-4.139-3.768 0-6.604 3.017-6.604 6.693 0 3.674 3.488 5.211 6.322 6.561l6.693 3.484c2.658 1.674 4.007 3.817 4.007 6.977 0 5.808-5.3 10.181-10.98 10.181-4.881 0-8.693-3.017-10.326-7.529l1.959-.885c1.488 3.717 4.229 6.327 8.461 6.327 4.606 0 8.652-3.631 8.652-8.28 0-3.947-4.046-5.621-7.073-7.113l-6.324-3.354c-2.324-1.443-3.625-3.482-3.625-6.277 0-5.205 3.721-8.881 8.976-8.881 3.532 0 6.885 1.905 8.562 4.922l-1.586 1.313z"
      />
      <path
        fill="#1A1919"
        d="M204.413 202.378h-2.229V169.4h-9.072v-2.094h20.367v2.094h-9.066v32.978"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M204.413 202.378h-2.229V169.4h-9.072v-2.094h20.367v2.094h-9.066z"
      />
      <path
        fill="#1A1919"
        d="M229.622 171.822l-6.883 16.924h13.719l-6.836-16.924zm-7.721 19.019l-4.697 11.532h-2.282l14.7-36.227 14.65 36.227h-2.281l-4.698-11.532h-15.392z"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M229.622 171.822l-6.883 16.924h13.719l-6.836-16.924zm-7.721 19.019l-4.697 11.532h-2.282l14.7-36.227 14.65 36.227h-2.281l-4.698-11.532h-15.392z"
      />
      <path
        fill="#1A1919"
        d="M280.411 203.539l-29.444-31.301v30.14h-2.228v-35.537l29.441 31.071v-30.606h2.231v36.233"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M280.411 203.539l-29.444-31.301v30.14h-2.228v-35.537l29.441 31.071v-30.606h2.231z"
      />
      <path
        fill="#1A1919"
        d="M295.151 200.279c4.607 0 8.418-.93 11.766-4.233 2.976-2.968 4.652-6.972 4.652-11.16 0-4.463-1.766-8.65-5.069-11.67-3.349-3.023-6.98-3.81-11.349-3.81h-4.047v30.873h4.047zm-6.277-32.969h6.324c5.121 0 9.168.832 13.025 4.414 3.672 3.449 5.58 8.137 5.58 13.162 0 4.84-1.865 9.444-5.396 12.834-3.86 3.725-8.002 4.653-13.209 4.653h-6.324V167.31z"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M295.151 200.279c4.607 0 8.418-.93 11.766-4.233 2.976-2.968 4.652-6.972 4.652-11.16 0-4.463-1.766-8.65-5.069-11.67-3.349-3.023-6.98-3.81-11.349-3.81h-4.047v30.873h4.047zm-6.277-32.969h6.324c5.121 0 9.168.832 13.025 4.414 3.672 3.449 5.58 8.137 5.58 13.162 0 4.84-1.865 9.444-5.396 12.834-3.86 3.725-8.002 4.653-13.209 4.653h-6.324V167.31z"
      />
      <path
        fill="#1A1919"
        d="M330.364 171.822l-6.891 16.924H337.2l-6.836-16.924zm-7.727 19.019l-4.695 11.532h-2.277l14.699-36.227 14.646 36.227h-2.279l-4.701-11.532h-15.393z"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M330.364 171.822l-6.891 16.924H337.2l-6.836-16.924zm-7.727 19.019l-4.695 11.532h-2.277l14.699-36.227 14.646 36.227h-2.279l-4.701-11.532h-15.393z"
      />
      <path
        fill="#1A1919"
        d="M355.239 183.677c2.185 0 4.375-.088 6.14-1.623 1.674-1.351 2.461-3.445 2.461-5.535 0-2.602-1.209-5.211-3.718-6.326-1.86-.887-4.227-.793-6.272-.793h-1.443v14.277h2.832zm12.281 18.701h-2.559l-11.439-16.611h-1.115v16.611h-2.237v-35.072h4.375c2.838 0 5.625.043 8 1.772 2.506 1.765 3.53 4.554 3.53 7.529 0 6.098-4.231 9.258-10.043 9.16l11.488 16.611z"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M355.239 183.677c2.185 0 4.375-.088 6.14-1.623 1.674-1.351 2.461-3.445 2.461-5.535 0-2.602-1.209-5.211-3.718-6.326-1.86-.887-4.227-.793-6.272-.793h-1.443v14.277h2.832zm12.281 18.701h-2.559l-11.439-16.611h-1.115v16.611h-2.237v-35.072h4.375c2.838 0 5.625.043 8 1.772 2.506 1.765 3.53 4.554 3.53 7.529 0 6.098-4.231 9.258-10.043 9.16l11.488 16.611z"
      />
      <path
        fill="#1A1919"
        d="M379.844 200.279c4.602 0 8.418-.93 11.768-4.233 2.974-2.968 4.648-6.972 4.648-11.16 0-4.463-1.763-8.65-5.066-11.67-3.354-3.023-6.977-3.81-11.35-3.81h-4.047v30.873h4.047zm-6.277-32.969h6.322c5.119 0 9.168.832 13.022 4.414 3.673 3.449 5.582 8.137 5.582 13.162 0 4.84-1.856 9.444-5.397 12.834-3.857 3.725-7.998 4.653-13.207 4.653h-6.322V167.31z"
      />
      <path
        stroke="#1A1919"
        strokeWidth={strokeWidth}
        d="M379.844 200.279c4.602 0 8.418-.93 11.768-4.233 2.974-2.968 4.65-6.972 4.65-11.16 0-4.463-1.765-8.65-5.068-11.67-3.354-3.023-6.977-3.81-11.35-3.81h-4.047v30.873h4.047zm-6.277-32.969h6.322c5.119 0 9.168.832 13.022 4.414 3.673 3.449 5.582 8.137 5.582 13.162 0 4.84-1.856 9.444-5.397 12.834-3.857 3.725-7.998 4.653-13.207 4.653h-6.322V167.31z"
      />
    </g>
  </svg>
);

export default SEKLogo;